import { render, staticRenderFns } from "./SectionTab.vue?vue&type=template&id=c8e6aaf8&scoped=true&"
import script from "./SectionTab.vue?vue&type=script&lang=js&"
export * from "./SectionTab.vue?vue&type=script&lang=js&"
import style0 from "./SectionTab.vue?vue&type=style&index=0&id=c8e6aaf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e6aaf8",
  null
  
)

export default component.exports